
export default {
  props: {
    validated: Boolean
  },
  data() {
    return {
      subscriptionTypes: [],
      subscriptionSelected: null
    }
  },
  async fetch() {
    try {
      if (!this.products || !this.products.length) {
        await this.$store.dispatch('getProductsStripe')
      }
      this.subscriptionTypes = this.products.filter((prod) => prod.product.metadata.store_prod)
      this.subscriptionTypes = [...this.subscriptionTypes, { name: 'In Person Training', product: { id: 'inperson', name: 'In Person Training - ZIP Area 77079' } }]
    } catch (err) {
      console.log(err)
    }
  },
  fetchOnServer: true,
  watch: {
    subscriptionSelected() {
      this.$emit('selSub', this.subscriptionSelected)
    }
  },
  computed: {
    products() {
      return this.$store.state.stripeProds
    }
  }
}
